export const Device = {
    Android: function() {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function() {
        return (
            navigator.userAgent.match(/IEMobile/i) ||
            navigator.userAgent.match(/WPDesktop/i)
        );
    },
    isMobile: function() {
        return (
            Device.Android() ||
            Device.BlackBerry() ||
            Device.iOS() ||
            Device.Opera() ||
            Device.Windows()
        );
    },
    isIE: function() {
        // Internet Explorer > 10
        return (
            navigator.userAgent.indexOf('MSIE') !== -1 ||
            !!document.documentMode === true
        );
    },
};
